import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Actions, ofType } from '@ngrx/effects';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Vdd } from '@vi-iot/client';

import {
  RemoteDiagnosticsSnapshotsService,
  RemoteDiagnosticsSnapshotsStore,
  RemoteDiagnosticsStore,
  SnapshotType,
  VddDetailsListStore,
} from '@store';

import { RemoteDiagnosticsSnapshotsActions } from '../../../../../@store/remote-diagnostics-snapshots/remote-diagnostics-snapshots.actions';

@Component({
  selector: 'app-snapshot-dialog',
  templateUrl: './snapshot-dialog.component.html',
  styleUrls: ['./snapshot-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnapshotDialogComponent implements OnInit, OnDestroy {
  private ngUnsubscribe$: Subject<void> = new Subject<void>();
  readonly snapshotType = SnapshotType;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { installationId: number; gatewaySerial: string },
    public remoteDiagnosticsStore: RemoteDiagnosticsStore,
    public remoteDiagnosticsSnapshotsStore: RemoteDiagnosticsSnapshotsStore,
    public vddDetailsListStore: VddDetailsListStore,
    public remoteDiagnosticsSnapshotService: RemoteDiagnosticsSnapshotsService,
    private dialogRef: MatDialogRef<SnapshotDialogComponent>,
    private storeActions$: Actions
  ) {}

  ngOnInit(): void {
    this.remoteDiagnosticsSnapshotsStore.setInstallationVddList([]);
    this.remoteDiagnosticsSnapshotsStore.deleteAllParameters();
    this.remoteDiagnosticsSnapshotsStore.clearDateOfTheValuesRead();

    this.closeDialogAfterSnapshotHasBeenCreated();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
    this.remoteDiagnosticsSnapshotsStore.clearDateOfTheValuesRead();
  }

  removeVddFromList(vdd: Vdd): void {
    this.remoteDiagnosticsSnapshotsStore.deleteParameter(vdd);
  }

  removeAllVddsFromList(): void {
    this.remoteDiagnosticsSnapshotsStore.deleteAllParameters();
  }

  generateSnapshot(): void {
    this.remoteDiagnosticsSnapshotsStore.createSnapshot(
      this.data.installationId,
      SnapshotType.SNAPSHOT
    );
  }

  private closeDialogAfterSnapshotHasBeenCreated(): void {
    this.storeActions$
      .pipe(
        ofType(RemoteDiagnosticsSnapshotsActions.createSnapshotSuccess),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe(() => {
        this.dialogRef.close();
        this.remoteDiagnosticsSnapshotsStore.clearDateOfTheValuesRead();
      });
  }
}
